var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonwarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34936 38.5L23 0.999999L44.6506 38.5H1.34936Z",
    fill: "red",
    stroke: "",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonwarm);
export default __webpack_public_path__ + "static/media/Polygon warm.02b88cfcb46fd1664724b6b3d510f85d.svg";
export { ForwardRef as ReactComponent };